import React from "react";

// TODO: use mealMenuIds to get cross menu report
export const ViewAttendancePage = () => {
  return <>THIS IS THE VIEW ATTENDANCE PAGE</>;
};
